import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { transformFiType } from '../../../hepler/functions';
import sizeFontCustom from '../../Discovery/fontSize.styles';
import { useTranslation } from '../../../hooks/useTranslation';
import { keyboardFocusVisibleSx } from '../../../utils/a11y.utils';
import { useTheme } from '@emotion/react';
import { useState } from 'react';

function ChipSet({ customDetails, fiTypes }) {
	const { t } = useTranslation();
	const theme = useTheme();
	const isDark =
		customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const chipTextColor =
		customDetails?.secondaryTextColor ??
		(isDark ? '#9AA3A8' : theme.palette.black60);
	const maxFiSize = 3;
	const toolTipFitype = () =>
		fiTypes.slice(maxFiSize).map((fi) => {
			return (
				<Typography sx={{...sizeFontCustom.toolTipText, color: chipTextColor}} key={fi}>
					{transformFiType(fi)}
				</Typography>
			);
		});

	const [openToolTip, setOpenToolTip] = useState(false);

	const handleClick = () => {
		setOpenToolTip((prevState) => !prevState);
	};
	return (
		<div style={{ display: 'flex' }}>
			{fiTypes.slice(0, maxFiSize).map((info) => (
				<Chip
					key={info}
					variant="outlined"
					label={transformFiType(info)}
					size="small"
					sx={{
						mr: 0.5,
						mt: 0.5,
						fontSize: '0.675rem',
						width: 'fit-content',
						color: chipTextColor,
						borderColor: isDark ? '#757575' : theme.palette.black60,
					}}
				/>
			))}
			{fiTypes.length - maxFiSize > 0 && (
				<Tooltip
					title={toolTipFitype()}
					open={openToolTip}
					onClick={handleClick}
				>
					<Box
						component="button"
						type="button"
						aria-label={`${fiTypes.length - maxFiSize} ${t('common.buttons.showMore')}`}
						onClick={handleClick}
						sx={{
							display: 'flex',
							color: theme.palette.primary.main,
							mt: '0.1rem',
							alignItems: 'center',
							background: 'none',
							border: 'none',
							padding: '0.25rem',
							font: 'inherit',
							cursor: 'pointer',
							borderRadius: '4px',
							...keyboardFocusVisibleSx,
						}}
					>{`+ ${fiTypes.length - maxFiSize} ${t('common.buttons.showMore')}`}</Box>
				</Tooltip>
			)}
		</div>
	);
}

export default ChipSet;
